import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UploadProgressComponent } from './upload-progress/upload-progress.component';
import { IonicModule } from '@ionic/angular';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ImageViewerModalComponent } from './image-viewer-modal/image-viewer-modal.component';
import { CalendarPickerModalComponent } from './calendar-picker-modal/calendar-picker-modal.component';
import { UploadIndicatorComponent } from './upload-indicator/upload-indicator.component';
import { UploadDetailSheetComponent } from './upload-indicator/upload-detail-sheet.component';

@NgModule({
  declarations: [
    UploadProgressComponent,
    ImageViewerModalComponent,
    CalendarPickerModalComponent,
    UploadIndicatorComponent,
    UploadDetailSheetComponent,
  ],
  imports: [CommonModule, IonicModule, FontAwesomeModule],
  exports: [
    UploadProgressComponent,
    ImageViewerModalComponent,
    UploadIndicatorComponent,
  ],
})
export class UtilsModule {}
